import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../common/Reveal";
import { BlogList } from "./BlogList";

export const BlogTeaser = ({ eyebrow, title, titleAccent, vertical, channel, basePath, linkLabel, testId, bg = "bg-warmwhite" }) => (
  <section className={`${bg} py-20 lg:py-28`} data-testid={testId}>
    <div className="container-site">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <Reveal>
          <p className="eyebrow">{eyebrow}</p>
          <h2 className="mt-4 max-w-xl font-serif text-3xl tracking-tight text-ink sm:text-4xl">
            {title} <span className="italic text-burgundy">{titleAccent}</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Link to={basePath} className="link-arrow" data-testid={`${testId}-link`}>
            {linkLabel} <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
          </Link>
        </Reveal>
      </div>
      <BlogList vertical={vertical} channel={channel} basePath={basePath} limit={3} testId={`${testId}-list`} />
    </div>
  </section>
);
